module.exports = __webpack_public_path__ + "b0f1a886d90313c0f7880efb53a85880.jpg";